import React, { memo } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import DropZone from './DropZone/DropZone';

const FormGroupDropZone = ({
    name,
    notice,
    maxFileSizeMB,
    columnGridCount,
    contentBase64Encoded,
    title,
    ...restProps
}) => (
    <Field
        {...restProps}
        component={DropZone}
        name={name}
        props={{
            notice,
            maxFileSizeMB,
            columnGridCount,
            contentBase64Encoded,
            title,
        }}
    />
);

FormGroupDropZone.defaultProps = {
    notice: null,
    columnGridCount: 24,
    contentBase64Encoded: true,
    title: null
};

FormGroupDropZone.propTypes = {
    name: PropTypes.string.isRequired,
    notice: PropTypes.string,
    maxFileSizeMB: PropTypes.number.isRequired,
    contentBase64Encoded: PropTypes.bool,
    columnGridCount: PropTypes.number,
    title: PropTypes.string,
};

export default memo(FormGroupDropZone);
